module.exports = __webpack_public_path__ + "img/rotate-left.1168691d.svg";